import Button from 'components/button/Button';
import { Channel } from 'models/Channels';
import { useTranslation } from 'react-i18next';
import useFeatures from 'hooks/useFeatures';
import useImportBookingDotComPropertiesModalInit from '../useImportBookingDotComPropertiesModalInit';

const FooterModalNoConnection = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  const { allowChannelsV3 } = useFeatures();
  const { channelSettings } = useImportBookingDotComPropertiesModalInit();

  const isBookingDotComActive = !!channelSettings?.find(
    ({ enumId }) => enumId === Channel.booking_com,
  )?.isActive;

  const channelsListPath = allowChannelsV3
    ? '#/channels'
    : '#/channels-migrated';

  return (
    <Button
      data-testid="modal-save-button"
      className="btn btn-primary"
      href={
        isBookingDotComActive
          ? '#/channels/bookingdotcom/sync'
          : channelsListPath
      }
      onClick={onClose}
    >
      {t(
        'pageProperties.importBookingDotComPropertiesModal.goToBookingDotComChannelPageSubmit',
      )}
    </Button>
  );
};

export default FooterModalNoConnection;
